import { compareBootstrapSizes, useDimensions } from "../../libs/hooksLib"

export default function BootstrapSizeContainer({size = "xs", children}){

    const {window} = useDimensions();

    return(
        compareBootstrapSizes(window.bootstrapSize, size) >= 0 ? children : null
    )
}